/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface FileDto { 
    id?: number;
    enabled?: boolean;
    removed?: boolean;
    createDate?: string;
    modifyDate?: string;
    modifyUserId?: number;
    fileName?: string;
    mimeType?: string;
    size?: number;
    ref?: number;
    table?: string;
    guid?: string;
    fileHash?: string;
    folder?: string;
    bucket?: string;
    uploadUserId?: number;
    expireDate?: string;
}

